import { RoundAllocation } from "@bookings/bookings/api/reviewPackage/types";
import { DEFAULT_PAX } from "@quote/consts";
import { StateCreator } from "zustand";

import { State, SharedState } from "./types";

const initState: State = {
  roundAllocation: {} as RoundAllocation,
  tta: false,
  productCode: "",
  totalGolfers: DEFAULT_PAX,
  quoteRef: "",
};

export const createSharedState: StateCreator<
  SharedState,
  [["zustand/devtools", never]]
> = (set) => ({
  ...initState,

  sharedActions: {
    setQuoteSharedState: (quoteState: Partial<State>) => {
      set(
        (preState) => ({ ...preState, ...quoteState }),
        undefined,
        "shared/setQuoteState",
      );
    },
  },

  sharedUtils: {},
});
